import _ from 'lodash';
import { AxiosError } from 'axios';

export interface BaseResponseError {
  getCode(): string;
  getError(): string;
  getMessage(): string;
  getStatusCode(): number;
}

export type ResponseError = {
  code: string;
  error: string;
  message: string;
  statusCode: number;
};

/**
 * ### Base Error class all domain error should impl
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class BaseError extends Error implements BaseResponseError {
  private code: string;
  private error: string;
  private statusCode: number;

  constructor({ code, message, statusCode, error }: ResponseError) {
    super(message);
    this.code = code;
    this.error = error;
    this.statusCode = statusCode;
  }

  getCode(): string {
    return this.code;
  }

  getStatusCode(): number {
    return this.statusCode;
  }

  getError(): string {
    return this.error;
  }

  getMessage(): string {
    return this.message;
  }
}

/**
 * ### Mapper for any error
 *
 * This will map any error that extends `BaseResponseError` | `AxiosError`
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class BackendResponseMapper {
  public static from<T extends BaseResponseError | AxiosError>(error: T): ResponseError {
    if (error instanceof AxiosError) {
      if ('response' in error) return _.get(error, 'response.data') as ResponseError;

      return {
        statusCode: 0,
        error: error.name,
        message: error.message,
        code: error.code ?? '',
      };
    }
    return {
      code: error.getCode(),
      error: error.getError(),
      message: error.getMessage(),
      statusCode: error.getStatusCode(),
    };
  }
}
